module.exports = __webpack_public_path__ + "img/studywayIcon1.41661fc8.png";